export var IdStatusClientGateway;
(function (IdStatusClientGateway) {
    IdStatusClientGateway["BadRequest"] = "bad request";
    IdStatusClientGateway["ApprovalMaintenance"] = "approvalMaintenance";
    IdStatusClientGateway["Approval"] = "approval";
    IdStatusClientGateway["ProductionMaintenance"] = "prodMaintenance";
    IdStatusClientGateway["Production"] = "production";
    IdStatusClientGateway["Outdated"] = "outdated";
    // Client-side only. Service doesn't return this one
    IdStatusClientGateway["Integration"] = "integration";
    IdStatusClientGateway["HotFix"] = "hotfix";
})(IdStatusClientGateway || (IdStatusClientGateway = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/client-gateway/IdStatusClientGateway.ts
// module id = 409
// module chunks = 3